<template>
  <recycle-scroller
    ref="scroller"
    class="recycle-scroller-ks scroller"
    :items="items"
    :item-size="itemSize"
    :buffer="buffer"
    :keyField="prop.value"
    :page-mode="pageMode"
    v-if="items.length"
  >
    <template v-slot="{ item, active, index }">
      <div
        v-if="type === 'select'"
        class="select-ppt__item"
        @click="changeSelectOptions(item)"
        :style="{display: active ? 'flex' : 'none'}"
        :class="{'selected': `${selectValue}` === `${item[prop.value]}`}"
      >
        <slot v-bind:item="item" v-bind:active="active" v-bind:prop="prop" v-bind:index="index"></slot>
      </div>
      <div v-else>
        <slot :style="{display: active ? 'flex' : 'none'}"  :item="item" :active="active" :prop="prop" :index="index"></slot>
      </div>

    </template>
  </recycle-scroller>
</template>

<script>
// https://github.com/Akryum/vue-virtual-scroller
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

export default {
  components: {
    RecycleScroller
  },
  props: {
    pageMode: Boolean,
    type: {
      type: String,
      default: 'select'
    },
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Object, String, Number],
      defalut: null
    },
    /**
     * itemSize未设置或设置为null，虚拟滚动体将切换到可变大小模式。然后，您需要使用Item元素的大小在Item对象上公开一个Number字段。
     * const items = [ { id: 1, size: 64 },  {id: 2, size: 32},...item ]
     */
    itemSize: {
      type: Number,
      default: null
    },
    buffer: {
      type: Number,
      default: 200
    },
    prop: {
      type: Object,
      defalut: {
        value: 'value',
        text: 'text'
      }
    }
  },
  data () {
    return {
      selectValue: null
    }
  },
  methods: {
    changeSelectOptions (row) {
      const hasValue = typeof this.value !== 'undefined'
      if (hasValue) {
        this.$emit('input', row[this.prop.value])
      }
      new Promise(resolve => {
        const fun = (data) => {
          resolve(data)
        }
        this.$emit('selected', row, hasValue ? resolve(row[this.prop.value]) : fun)
      }).then(data => {
        if (data instanceof Error) return
        this.selectValue = data
      })
    },
    setValue (value) {
      this.selectValue = value
    }
  },
  watch: {
    items (val, old) {
      if (val.length !== old.length) {
        this.$refs['scroller'].scrollToPosition(0)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.select-ppt__item {
  height: 32px;
  line-height: 32px;
  padding: 0 12px;

  &:hover {
    background:#e6f7ff;
    cursor: pointer;
  }
  &.selected {
    color: rgba(0, 0, 0, 0.65);
    font-weight: 600;
    background-color: #fafafa;
  }
}
</style>
